export default __webpack_public_path__ + "static/media/user-vehicle-line.2a3e4b11.svg";